// extracted by mini-css-extract-plugin
export var image = "gy_dj";